'use client'

import { Picture } from 'src/components/Picture'
import { ImageType } from 'src/components/Picture/Picture.types'

import classes from './styles.module.scss'

export type Props = {
  url: string
  alt: string
}

export default function OptimizedImage({ url, alt }: Props) {
  if (!url) {
    return null
  }

  return <Picture src={url} alt={alt} loading='lazy' type={ImageType.PROMOTIONS} className={classes.image} />
}
